// frontend/src/components/charts/ScansByDayChart.jsx
import React from "react";
import PropTypes from "prop-types";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  ResponsiveContainer,
} from "recharts";
import { format, parseISO } from "date-fns";
import ChartCard from "./ChartCard";

/**
 * ScansByDayChart — daily scan line chart over a zero-filled date series.
 *
 * @param {{
 *   data: Array<{ date: string, count: number }>,
 *   title?: string,
 *   height?: number
 * }} props
 */
function ScansByDayChart({ data, title = "Scans by day", height = 240 }) {
  const chartData = data.map((d) => ({
    label: format(parseISO(d.date), "d MMM"),
    count: d.count,
  }));
  const isEmpty =
    chartData.length === 0 || chartData.every((d) => d.count === 0);

  return (
    <ChartCard title={title} isEmpty={isEmpty}>
      <ResponsiveContainer width="100%" height={height}>
        <LineChart
          data={chartData}
          margin={{ top: 8, right: 24, bottom: 0, left: 0 }}
        >
          <CartesianGrid
            strokeDasharray="3 3"
            stroke="#f0f0f0"
            vertical={false}
          />
          <XAxis
            dataKey="label"
            tick={{ fontSize: 11, fill: "#6b7280" }}
            tickLine={false}
            axisLine={false}
            minTickGap={24}
          />
          <YAxis
            allowDecimals={false}
            tick={{ fontSize: 11, fill: "#6b7280" }}
            tickLine={false}
            axisLine={false}
            width={32}
          />
          <Tooltip />
          <Line
            type="monotone"
            dataKey="count"
            stroke="#2563eb"
            strokeWidth={2}
            dot={false}
          />
        </LineChart>
      </ResponsiveContainer>
    </ChartCard>
  );
}
ScansByDayChart.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({ date: PropTypes.string, count: PropTypes.number }),
  ).isRequired,
  title: PropTypes.string,
  height: PropTypes.number,
};

export default ScansByDayChart;
